import axios from "../config/axios";
import Constants from "../data/Constants";

export const deliverNotification = async (data) => {
  return await axios
    .post(Constants.ENDPOINTS.NOTIFICATION.DELIVER, data)
    .then((res) => {
      return res.data.result;
    });
};

export const getAdminNotifications = async (data) => {
  return await axios
    .get(Constants.ENDPOINTS.NOTIFICATION.GET_ADMIN_NOTIFICATIONS)
    .then((res) => {
      return res.data.result;
    });
};
